module.exports = "/images/in.svg?9bec472131fc06fcb0055b00dfc52be9";